import styled from 'styled-components'
import Typewriter from 'typewriter-effect'
import { useEffect, useRef, useState } from 'react'
import useOnScreen from '../../../hooks/useOnScreen'
import { getCloudinaryImageUrl } from '@utils/images'



const Module2 = (props: any) => {
  const ref = useRef<HTMLDivElement>(null)
  const isItemReacted = useOnScreen(ref as any)
  const [itemHasAppeared, setItemHasAppeared] = useState(false)

  useEffect(() => {
    // Make itemHasAppeared true when the item is visible, and never set it back to false
    if (isItemReacted) {
      setItemHasAppeared(true)
    }
  }
    , [isItemReacted])

  return (
    <StyledComponent $block3Image1={props.block3Image1} $block3Image2={props.block3Image2} className=''>
      <div className='snap-section-start theme-black show-floating-logos relative top-[10px]' />
      <div className='wrapper'>
        <div className='img-1' />
        <div className='text' ref={ref}>
          {itemHasAppeared && <Typewriter
            options={{
              autoStart: true,
            }}
            onInit={(typewriter) => {
              typewriter.typeString(props.block3Heading)
                .callFunction(() => {
                  // console.log('String typed out!');
                })
                .pauseFor(2500)
                // .deleteAll()
                // .callFunction(() => {
                //   console.log('All strings were deleted');
                // })
                .start()
            }}
          />}
        </div>

        <div className='img-2' />
      </div>

    </StyledComponent>
  )
}

const StyledComponent = styled.div<any>`
  scroll-snap-align: start;
  > div.wrapper {
    padding: 50px 0;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    align-items: center;
    
    .img-1 {
      flex-grow: 1;
      background-image: url(${(props) => props.$block3Image1?.data?.attributes.url && getCloudinaryImageUrl(props.$block3Image1?.data.attributes.url, 'dpr_auto,f_auto,fl_progressive')});
      background-size: cover;
      background-position: center;
      width: 240px;

      @media (min-width: 1024px) {
        width: 12vw;
      }
    }
    .text {
      font-size: 30px;
      font-weight: 800;
      line-height: 22px;
      text-align: center;
      font-family: var(--abcdfont);
      width: 65%;

      @media (min-width: 1024px) {
        font-size: 4.2vw;
        line-height: 3.3vw;
        width: 49%;
        margin-top: -3px;
        margin-bottom: -3px;
        letter-spacing: -5px;
        word-spacing: 5px;
      }
    }
    .img-2 {
      flex-grow: 1;
      background-image: url(${(props) => props.$block3Image2?.data?.attributes.url && getCloudinaryImageUrl(props.$block3Image2?.data.attributes.url, 'dpr_auto,f_auto,fl_progressive')});
      background-size: cover;
      background-position: center;
      width: 240px;

      @media (min-width: 1024px) {
        width: 12vw;
      }
    }

    img {
      height: auto;
    }
  }
`

export default Module2